import {
    Grid,
    IconButton,
    InputAdornment,
    TextField,
    Typography } from "../../ui";
import React,
    { useState } from "react";
import { useSelector } from "react-redux";
import LoadingPaper from "../../global/LoadingPaper";
import SearchIcon from '../../ui/icons/Search';
import {
  getAuthSession,
  isEmpty,
  SEARCHROOM,
  SUCCESS
} from "../../../constants/constant";
import { snpAxios } from "../../global/api";
const DialogHotelContent = ({ externalBillDetails, setExternalBillDetails , fireSnackBarMsg }) => {

    const storeActiveShopHash = useSelector(state => state.setActiveShopHashReducer.activeShopHash);
    const storeApiUrl = useSelector(state => state.setApiUrlReducer.MAINURL.INITIAL_BASE_URL);
    const [hotelDialogLoader, setHotelDialogLoader] = useState(false);

    const checkRoom = async () => {
        try {
            if (isEmpty(externalBillDetails.hotelBillNo)) {
                fireSnackBarMsg({msg:"Plase Enter Room Details"});
                return;
            }
            setHotelDialogLoader(true);
            const mUrl = `${storeApiUrl.BACKEND_BASE_URL}${SEARCHROOM}`;
            const data = {
                jcJson: {
                    apiToken: getAuthSession().apiToken,
                    roomNo: externalBillDetails.hotelBillNo,
                    shopHash: storeActiveShopHash.id,
                }
            };
            const response = await snpAxios.post(
                mUrl,
                data
            );
            if (response.data.status === SUCCESS) {
                const payLoad = response.data.jcJson;
                setExternalBillDetails(prev=> ({
                    ...prev,
                    ...payLoad,
                }));
            }
            setHotelDialogLoader(false);
        } catch (error) {
            console.error("checkRoom",error);
            setHotelDialogLoader(false);
        }
    }

    return (
        <LoadingPaper
            loader={hotelDialogLoader}>
            <Grid container spacing={0} display="flex" alignItems="center" sx={{
                m: 1, p: 1
            }} >

                {
                    !externalBillDetails.saved && <Grid item xs={12}>
                        <TextField
                            id="searchRoom"
                            name="searchRoom"
                            fullWidth
                            variant="filled"
                            size="small"
                            label="Enter Room No"
                            defaultValue={externalBillDetails.hotelBillNo}
                            onChange={(e) => setExternalBillDetails(prev => ({
                                ...prev, hotelBillNo: e.target.value,
                            }))}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="start">
                                        <IconButton onClick={checkRoom}>
                                            <SearchIcon />
                                        </IconButton>
                                    </InputAdornment>
                                )
                            }}
                        />
                    </Grid>
                }
                {
                    externalBillDetails.saved &&
                    <Grid item xs={12}>
                        <Typography variant="p" component="div" style={{ color: "#2f1160", whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>Room No :{externalBillDetails.hotelBillNo}</Typography>
                    </Grid>
                }
                <Grid item xs={12}>
                    <Typography variant="p" component="div" style={{ color: "#2f1160", whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>Room Book Status :{externalBillDetails.roomBooked ? "Booked" : "Empty"}</Typography>
                </Grid>
                {
                    externalBillDetails.custName && <Grid item xs={12}>
                        <Typography variant="p" component="div" style={{ color: "#2f1160", whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }} >Customer Name :{externalBillDetails.roomBooked ? externalBillDetails.custName : ""}</Typography>
                    </Grid>
                }
            </Grid>
        </LoadingPaper>
    );
};
export default DialogHotelContent;